import IconWithPopover from '@components/IconWithPopover/IconWithPopover'
import { RHFCheckbox } from '@components/RHFInputs'
import { Divider, Stack, Typography } from '@mui/material'
import { useWatch } from 'react-hook-form'

import { chooseColor } from './BasketSettings.utils'

/**
 * Fields controlling when similar matches are excluded
 */
export default function ExcludeSimilar() {
	const [restrictedManufacturer, sameManufacturer, preferExactMatch] = useWatch({
		name: ['restrictedManufacturer', 'sameManufacturer', 'preferExactMatch'],
	})

	return (
		<>
			<Typography variant="h6" sx={{ pt: 2 }}>
				Exclude Similar Matches When
			</Typography>

			<Divider />

			{/* Restricted MFG */}
			<Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
				<RHFCheckbox name="restrictedManufacturer" data-testid="settings-restricted-manufacturer" />
				<Typography variant="body2" color={chooseColor(restrictedManufacturer)}>
					It&apos;s from a manufacturer on the restricted list
				</Typography>
				<IconWithPopover>
					When checked, products from manufacturers <br />
					on the restricted list will not be matched.
				</IconWithPopover>
			</Stack>

			{/* Same MFG */}
			<Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
				<RHFCheckbox name="sameManufacturer" data-testid="settings-same-manufacturer" />
				<Typography variant="body2" color={chooseColor(sameManufacturer)}>
					It’s a product from the same manufacturer
				</Typography>
				<IconWithPopover>
					When checked, will not allow switches to a <br />
					different product from the same manufacturer.
				</IconWithPopover>
			</Stack>

			{/* Prefer Exact */}
			<Stack spacing={2} direction="row" sx={{ alignItems: 'center' }}>
				<RHFCheckbox name="preferExactMatch" data-testid="settings-prefer-exact-match" />
				<Typography variant="body2" color={chooseColor(preferExactMatch)}>
					Prefer exact matches over switches
				</Typography>
				<IconWithPopover>
					When checked, chooses exact matches over suggesting <br />a switch even if the switch has
					better total savings.
					<br />
				</IconWithPopover>
			</Stack>
		</>
	)
}
